import useMobileLayout from '@/hooks/use-mobile-layout';
import useChatWidgetEffectiveOpen from './use-chat-widget-effective-open';
import useChatWidgetEnabled from './use-chat-widget-enabled';
import useChatWidgetLayout from './use-chat-widget-layout';
import useChatWidgetLockedFullscreen from './use-chat-widget-locked-fullscreen';
import useInvestigationDock from './use-investigation-dock';

/**
 * Whether the chat is presenting fullscreen and so overlays the content card.
 * Mirrors the widget's `fullscreen` presentation — including the investigation dock
 * beating a stored fullscreen, or the overlay would mount empty over a docked page;
 * used by ChatWidgetFullscreenSlot (to mount the overlay) and default-layout (to drop
 * <main>'s scroll while covered). Uses effectiveOpen so shell routes (which imply open
 * without persisting it) still mount the overlay.
 */
const useChatWidgetFullscreenActive = () => {
  const enabled = useChatWidgetEnabled();
  const isMobile = useMobileLayout();
  const effectiveOpen = useChatWidgetEffectiveOpen();
  const {
    isFullscreen
  } = useChatWidgetLayout();
  const lockedFullscreen = useChatWidgetLockedFullscreen();
  const lockedSidebar = useInvestigationDock();
  return enabled && effectiveOpen && (isMobile || lockedFullscreen || isFullscreen && !lockedSidebar);
};
export default useChatWidgetFullscreenActive;